import { useQuery } from "@tanstack/react-query";

import type {
    IWebsiteAnalysisTrafficRequestParams,
    IWebRanksResponseData,
    RankByMode,
} from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

interface ICompareWebRanksOptions {
    controller?: string;
    enabled?: boolean;
}

export const useCompareWebRanksData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    rankByMode: RankByMode,
    { controller, enabled = true }: ICompareWebRanksOptions = {},
) => {
    return useQuery<IWebRanksResponseData>({
        queryKey: ["webRanksCompare", params, rankByMode, controller],
        queryFn: () =>
            WebsiteAnalysisApiService.getInstance().getCompareWebRanksData(params, rankByMode, controller),
        enabled,
    });
};
